import * as React from "react";
import {useOptimizedAudioAvailableQuery} from "../../types.d";

export const OptimizedAudio = props => {
    const optimized = useOptimizedAudioAvailableQuery({
        variables: {
            id: 1,
            fileUrl: props.url,
            noTimeout: true
        }
    })

    return <audio controls={true} src={optimized?.data?.optimizedAudioAvailable?.url ? (
        optimized?.data?.optimizedAudioAvailable?.url
    ) : props.url} />
}
